/**
 * One CSV cell for a Polish spreadsheet (semicolon-separated, see
 * downloadCsv). Text that starts like a formula is made inert with a leading
 * apostrophe: names reach the books from the public contact form, and
 * =HYPERLINK(…) would open in Excel as a live link. Numbers — a negative
 * balance „-20,00” — are left alone.
 */
export function csvCell(v: string | number): string {
  let s = String(v)
  if (typeof v === 'string' && /^[=+\-@\t\r]/.test(s) && !/^-?\d+(,\d+)?$/.test(s)) s = `'${s}`
  return /[";\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s
}

/** A semicolon CSV with a BOM, so Excel opens Polish letters and decimal commas as they are. */
export function downloadCsv(name: string, rows: (string | number)[][]): void {
  const text = '﻿' + rows.map((r) => r.map(csvCell).join(';')).join('\r\n')
  const url = URL.createObjectURL(new Blob([text], { type: 'text/csv;charset=utf-8' }))
  const a = document.createElement('a')
  a.href = url
  a.download = name
  document.body.appendChild(a)
  a.click()
  a.remove()
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}
